import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const terminationForConvenienceFilterLabel = () => t({
    message: 'Termination for convenience',
    comment: 'Insights: Termination for convenience filter',
});
export function TerminationForConvenienceFilter() {
    return (<BooleanFilter name="metadataDocumentTerminationForConvenience" label={terminationForConvenienceFilterLabel()}/>);
}
